import { subject } from '@casl/ability'
import { useAbility } from '@casl/react'
import './styles.scss'
import { Typography } from 'components/Typography'
import { useRFPCreateSurveyContext } from 'features/RFP/RFPSurvey/CreateSurvey/Providers/RFPCreateSurveyContextProvider'
import { useRFPVotingContext } from 'features/RFP/RFPDetails/Providers/RFPVotingContextProvider'
import {
  AbilityContext,
  ACTIONS,
  AppAbility,
  SUBJECTS
} from 'features/Permission'
import { useRFPDetailsContext } from 'features/RFP/RFPDetails/Providers/RFPDetailsContextProvider'
import { useRFPSurveyContext } from 'features/RFP/RFPDetails/Providers/RFPSurveyContextProvider'
import { SurveyPreviewCategory } from './SurveyPreviewCategory'

interface IProps {
  isSinglePagePreview?: boolean
}

const SurveyPreview = ({ isSinglePagePreview = false }: IProps) => {
  const ability = useAbility<AppAbility>(AbilityContext)

  const rfpDetailsContext = useRFPDetailsContext()
  const rfpSurveyContext = useRFPSurveyContext()
  const rfpCreateSurveyContext = useRFPCreateSurveyContext()
  const rfpVotingContext = useRFPVotingContext()

  const { data } = rfpDetailsContext.state
  const { isSurveySubmitted } = rfpSurveyContext.state
  const {
    activeSelectionList,
    activeCategoryIndex,
    activeCategoryName,
    pagesCount,
    fullListPreview
  } = rfpCreateSurveyContext.state
  const { setActiveSelectionList } = rfpCreateSurveyContext.actions
  const { isVotingInProgress } = rfpVotingContext.state

  const isVotingDisabled =
    ability.cannot(ACTIONS.VOTE, subject(SUBJECTS.SURVEY, { ...data })) ||
    !isVotingInProgress ||
    isSurveySubmitted

  return (
    <div className="rfp-create-survey-preview survey-preview">
      <Typography.Body1>
        Please, rank vendors by dragging them up and down
      </Typography.Body1>
      {isSinglePagePreview ? (
        fullListPreview.vote.map((listItem, idx) => (
          <SurveyPreviewCategory
            isSurveySubmitted={isSurveySubmitted}
            isVotingDisabled={isVotingDisabled}
            pagesCount={pagesCount}
            setActiveSelectionList={setActiveSelectionList}
            categoryName={listItem.category.name}
            activeIdx={idx}
            vendors={listItem.ranked_vendors.map((item) => item.vendor)}
            proxyVoter={listItem.ranked_vendors[0]?.proxy_voter}
            rfpCreatorUuid={data.creator?.uuid}
          />
        ))
      ) : (
        <SurveyPreviewCategory
          isSurveySubmitted={isSurveySubmitted}
          isVotingDisabled={false}
          pagesCount={pagesCount}
          setActiveSelectionList={setActiveSelectionList}
          categoryName={activeCategoryName}
          activeIdx={activeCategoryIndex}
          vendors={activeSelectionList}
          rfpCreatorUuid={data.creator?.uuid}
        />
      )}
    </div>
  )
}

export default SurveyPreview
